import { useTranslation } from 'react-i18next';

import CustomModal, { CustomModalProps } from 'components/shared/CustomModal/CustomModal';
import { useErrorDescriptions } from 'constants/errorDescriptions';
import { useModal } from 'hooks/useModal';
import { HTTPService } from 'service';
import { logNetworkError } from 'utils/logNetworkError';

import styles from './RemoveOrderModal.module.css';

type RemoveOrderModalProps = CustomModalProps & {
   selectedOrderId: string;
   onSuccessRemoveOrder: () => void;
};

const RemoveOrderModal = ({
   selectedOrderId,
   onSuccessRemoveOrder,
   onClose,
   ...props
}: RemoveOrderModalProps) => {
   const { t } = useTranslation();
   const { isLoading, errorInfo, setIsLoading, setErrorInfo, closeModalHandler } = useModal({
      onClose,
   });

   const { DEFAULT_ERROR_DESCRIPTIONS } = useErrorDescriptions();

   const handleRemoveOrder = () => {
      setIsLoading(true);
      HTTPService.deleteOrder(selectedOrderId)
         .then(() => {
            onSuccessRemoveOrder();
            closeModalHandler();
         })
         .catch(error => {
            setErrorInfo(DEFAULT_ERROR_DESCRIPTIONS.UNKNOWN);
            logNetworkError(error);
         })
         .finally(() => setIsLoading(false));
   };

   return (
      <CustomModal
         {...props}
         icon="TRASH"
         innerTitle={t('order_details_page.remove_order')}
         error={errorInfo}
         modalContentClassName={styles.modalContent}
         isLoading={isLoading}
         onClose={closeModalHandler}
         primaryButtonProps={{
            text: t('order_details_page.remove_order'),
            variant: 'filled-danger',
            onClick: handleRemoveOrder,
         }}
         secondaryButtonProps={{
            text: t('modals.deleteStorage.cancel'),
            variant: 'outlined-danger',
            onClick: closeModalHandler,
         }}
      >
         <div className={styles.descriptionContainer}>
            <p className={styles.plainText}>{t('remove_order_modal.confirm')}</p>
            <p className={styles.boldBlackText}>{t('cancel_pallet_report_modal.irreversible')}</p>
         </div>
      </CustomModal>
   );
};

export default RemoveOrderModal;
